import { Button, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

const EmptyKey = ({ setIsEnableCreate }) => {
  const theme = useTheme();
  return (
    <>
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.grey[600],
          fontSize: '22px'
        }}
      >
        Aún no has generado tu API KEY
      </Typography>
      <Stack>
        <Button variant="outlined" onClick={() => setIsEnableCreate(true)}>
          Generar API KEY
        </Button>
      </Stack>
    </>
  );
};

EmptyKey.propTypes = { setIsEnableCreate: PropTypes.func };

export default EmptyKey;
